const Loading: React.FC = () => (
    <div className="loading">
        <i className="fal fa-spinner fa-spin"></i>
    </div>
);

export default Loading;
